import { render, staticRenderFns } from "./ProductionReport.vue?vue&type=template&id=1332bfa4&scoped=true&"
import script from "./ProductionReport.vue?vue&type=script&lang=js&"
export * from "./ProductionReport.vue?vue&type=script&lang=js&"
import style0 from "./ProductionReport.vue?vue&type=style&index=0&id=1332bfa4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1332bfa4",
  null
  
)

export default component.exports